import axios from "axios"; // 引用axios
import qs from 'qs';
import config from "@/network/config";

//让请求携带cookic信息
axios.defaults.withCredentials = true

//普通的get和post请求
const instance = axios.create({
	baseURL: config.baseUrl.dev,
	timeout: 60000,
	// post 使用form-data
	transformRequest: [function(data) {
		data = qs.stringify(data);
		return data;
	}],
	withCredentials: true,
	crossDomain: true,
	headers: {
		'apiVersion': 'v1',
		'Content-Type': 'application/x-www-form-urlencoded'
	}
});

//验证图片、资源下载使用
const instanceImage = axios.create({
	baseURL: config.baseUrl.dev,
	timeout: 60000,
	responseType: 'blob',
	withCredentials: true,
	crossDomain: true,
	// post 使用form-data
	transformRequest: [function(data) {
		data = qs.stringify(data);
		return data;
	}],
	headers: {
		'apiVersion': 'v1',
	}
});

//发送文件类型的请求
const instanceMultipart = axios.create({
	baseURL: config.baseUrl.dev,
	timeout: 60000,
	withCredentials: true,
	crossDomain: true,
	headers: {
		'apiVersion': 'v1',
		'Content-Type': 'multipart/form-data' //修改请求头
	}
});


//get请求
export function get(url, params = {}) {
	// console.log('22222')
	// console.log(params)
	return new Promise((resolve, reject) => {
		instance.get(url, {
				params: params,
			})
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

export function getImage(url, params = {}) {
	return new Promise((resolve, reject) => {
		instanceImage.get(url, {
				params: params,
			})
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

export function postBlob(url, data = {}) {
	return new Promise((resolve, reject) => {
		instanceImage.post(url, data)
			.then((response) => {
				resolve(response);
			})
			.catch((err) => {
				reject(err);
			});
	});
}



//post请求
export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		instance.post(url, data).then(
			(response) => {
				resolve(response.data);
			},
			(err) => {
				reject(err);
			}
		);
	});
}

//发送文件的请求
export function postMultipart(url, data = {}) {
	return new Promise((resolve, reject) => {
		instanceMultipart.post(url, data).then(
			(response) => {
				resolve(response.data);
			},
			(err) => {
				reject(err);
			}
		);
	});
}


//-------------------- axios的拦截器----------------------
// 1.请求拦截的作用
// instance.interceptors.request.use(config => {
//    console.log('进入请求拦截'  );
//   // 1.比如config中的一些信息不符合服务器的要求
//   // 2.比如每次发送网络请求时, 都希望在界面中显示一个请求的图标
//   // 3.某些网络请求(比如登录(token)), 必须携带一些特殊的信息
//   return config
// }, err => {
//   // console.log(err);
// })

// 2.响应拦截
// instance.interceptors.response.use(res => {
//     console.log('进入相应拦截');
//   return res
// }, err => {
//   console.log(err);
// })

// 请求拦截器  post 使用form-data
// instance.interceptors.request.use(
//   config => {
//     config.data = qs.stringify(config.data) // 转为formdata数据格式
//     return config
//   },
//   error => Promise.error(error)
// )




